module.exports = __webpack_public_path__ + "static/media/MUSEA-Colorwheel.2d6e8aaf.png";